// @flow
import React from "react";
import I18n from "../../../i18n/I18n";
import { LocaleLink } from "../../common";
import Helper from "../../../helper/Helper";
import styles from "./SalesDetails.scss";

type Props = {
  data: Object,
  penalty: undefined | boolean
};
const TabularData = (props: Props) => {
  const { data, penalty } = props;
  return (
    <div className={styles.saleTable}>
      <div className={styles.saleHeader}>{data.header}</div>
      {penalty && data.details ? (
        <div className={styles.penaltyDetail}>
          <div key="labels" className={styles.eachDetail}>
            <div className={styles.label}>
              {I18n.getText("sales.penalty-days")}
            </div>
            <div className={styles.label}>
              {I18n.getText("sales.penalty-percent")}
            </div>
          </div>
          {data.details.map((detail, idx) => {
            return (
              <div key={idx} className={styles.eachDetail}>
                <div className={styles.penaltyLabel}>{detail.label}</div>
                <div className={styles.value}>{detail.value}</div>
              </div>
            );
          })}
        </div>
      ) : data.details ? (
        data.details.map((detail, idx) => {
          const Comp = detail.link ? "a" : "div";
          return (
            <div key={idx} className={styles.eachDetail}>
              <div className={styles.label}>{detail.label}</div>
              <Comp
                className={styles.value}
                target="_blank"
                href={detail.link || null}
              >
                {detail.value}
              </Comp>
            </div>
          );
        })
      ) : (
        ""
      )}
    </div>
  );
};
export default TabularData;



// WEBPACK FOOTER //
// ./src/components/sales/salesDetails/TabularData.js